import { render, staticRenderFns } from "./ImageV2.vue?vue&type=template&id=5a4095fb&scoped=true"
import script from "./ImageV2.vue?vue&type=script&lang=js"
export * from "./ImageV2.vue?vue&type=script&lang=js"
import style0 from "./ImageV2.vue?vue&type=style&index=0&id=5a4095fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4095fb",
  null
  
)

export default component.exports